// @flow
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import MainTemplate from 'components/templates/MainTemplate'
import Breadcrumbs from 'components/shared/Breadcrumbs'
import Path from 'routes/path'
import TweetCampaignPage from 'components/pages/TweetCampaignPage'
import type { TweetCampaign } from 'types/campaign'
import { imagePath } from 'frontend_core/dist/helpers/image'
import graphql from './graphql'
import { setUIState, containerIds } from 'redux/modules/ui'

type PropTypes = {
  data: {
    tweetCampaign: TweetCampaign,
  },
  match: {
    params: {
      tweetCampaignUid: ?string,
    },
  },
  staticContext: Object,
  ui: {
    isClosingCampaignDetail: boolean,
  },
}

class TweetCampaignContainer extends Component<PropTypes> {
  constructor(props: PropTypes) {
    super(props)
    props.actions.setUIState(containerIds.TWEET_CAMPAIGN, {
      isClosingCampaignDetail: true,
    })
  }

  render() {
    const { data, ui } = this.props
    const { tweetCampaign, viewer } = data
    const { isClosingCampaignDetail } = ui
    if (tweetCampaign === null) {
      this.props.staticContext.status = 404
      return null
    }

    return (
      <MainTemplate
        title={tweetCampaign.pageTitle}
        description={tweetCampaign.pageDescription}
        image={
          tweetCampaign.ogImage
            ? tweetCampaign.ogImage
            : imagePath('www/common/ogimage.png')
        }
        {...this.props}
      >
        <Breadcrumbs breadcrumbs={tweetCampaign.breadcrumbs} />
        <TweetCampaignPage
          tweetCampaign={tweetCampaign}
          currentUser={viewer}
          onClickToggleCampaignDetail={() => {
            this.props.actions.setUIState(containerIds.TWEET_CAMPAIGN, {
              isClosingCampaignDetail: !isClosingCampaignDetail,
            })
          }}
          onClickCampaignDetail={() => {
            this.props.actions.setUIState(containerIds.TWEET_CAMPAIGN, {
              isClosingCampaignDetail: true,
            })
          }}
          isClosingCampaignDetail={isClosingCampaignDetail}
        />
      </MainTemplate>
    )
  }
}

function mapStateToProps(state: Object) {
  return state
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = { setUIState }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(graphql(TweetCampaignContainer)),
)



// WEBPACK FOOTER //
// ./src/containers/pages/TweetCampaignPage/index.jsx